<div class="alert-container {{typeAlert}}">
  <div class='icon'>
    <mat-icon svgIcon="{{iconName}}" *ngIf='iconName'></mat-icon>
    <img src='/assets/custom_svg/{{customIconName}}.svg' *ngIf='customIconName'>
  </div>
  <h1>{{title}}</h1>
  <p>{{message}}</p>
  <div class="btn-container">
    <ion-button clear class="secondary-btn" (click)="clickKoHandler()" *ngIf="buttonKO != undefined">{{buttonKO}}</ion-button>
    <ion-button clear class="primary-btn" (click)="clickOkHandler()" *ngIf="buttonOK != undefined">{{buttonOK}}</ion-button>
  </div>
</div>